import React from 'react';
import { Wrapper, Heading, HeadingContainer, Message } from './Banner.styled';
import { Icon } from 'lmc-ui-library';

interface Props {
  mode: 'default' | 'error' | 'warning' | 'success';
  heading: string;
  message?: string;
}

const Banner: React.FC<Props> = ({ mode = 'default', heading, message }) => {
  return (
    <Wrapper mode={mode}>
      <HeadingContainer>
        <Icon type="error" />
        <Heading>{heading}</Heading>
      </HeadingContainer>
      {message && <Message>{message}</Message>}
    </Wrapper>
  );
};

export default Banner;
